import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Input from 'components/forms/Input';
import Error from 'components/forms/Error';
import DatePicker from './DateTimePicker';


const InputWithTimezone = ({
  value, onClick, timezone, disabled,
}) => (
  <Input
    inputProps={{
      className: 'form-control',
      value: `${value} ${value && timezone ? `- ${timezone}` : ''}`,
      disabled,
      onClick,
    }}
  />);

const DateTimePickerField = ({
  input,
  className,
  minDate,
  maxDate,
  minTime,
  maxTime,
  withPortal,
  showTimeSelectOnly,
  dateFormat,
  showTimeSelect,
  disabled,
  timezone,
  defaultToNoon,
  meta: { touched, error },
}) => {
  const handleOnChange = (value) => {
    if (input.value === '' && value.getHours() === 0 && defaultToNoon) {
      // eslint-disable-next-line no-param-reassign
      value = value.setHours(12, 0, 0, 0);
    }
    input.onChange(value);
  };
  return (
    <React.Fragment>
      <DatePicker
        timeFormat="p"
        showTimeSelect={showTimeSelect}
        showTimeSelectOnly={showTimeSelectOnly}
        minDate={minDate}
        maxDate={maxDate}
        minTime={minTime}
        maxTime={maxTime}
        className={className}
        dateFormat={dateFormat}
        selected={input.value || null}
        onChange={handleOnChange}
        withPortal={withPortal}
        disabled={disabled}
        customInput={<InputWithTimezone timezone={timezone} disabled={disabled} />}
      />
      {touched && ((error && <Error error={error} />))}
    </React.Fragment>
  );
};

InputWithTimezone.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

InputWithTimezone.defaultProps = {
  disabled: false,
};

DateTimePickerField.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  className: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  minTime: PropTypes.instanceOf(Date),
  maxTime: PropTypes.instanceOf(Date),
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  withPortal: PropTypes.bool,
  showTimeSelectOnly: PropTypes.bool,
  dateFormat: PropTypes.string,
  showTimeSelect: PropTypes.bool,
  timezone: PropTypes.string,
  defaultToNoon: PropTypes.bool,
  disabled: PropTypes.bool,
};

DateTimePickerField.defaultProps = {
  className: '',
  minDate: null,
  disabled: false,
  maxDate: null,
  minTime: moment().startOf('day').toDate(),
  maxTime: moment().endOf('day').toDate(),
  withPortal: false,
  showTimeSelectOnly: false,
  showTimeSelect: true,
  meta: null,
  defaultToNoon: false,
  // https://github.com/Hacker0x01/react-datepicker/issues/1609
  // can't set this from settings because can't find a unified solution
  dateFormat: 'MMMM d, yyyy h:mm aa',
  timezone: '',
};

export default DateTimePickerField;
